import axios from 'axios';
import {config} from '../../config';

import store from '../store';

export class FormGridService {
    static getFormGrid(raceId, callback) {
        axios.get(`${config.serverUri}/formgrid/${raceId}?token=${store.getters.getUserAuthToken}`)
            .then((response) => {
                store.commit('setSelectedFormGrid', response.data[0]);
                callback(response.data[0]);
                
            })
            .catch((error) => {
                if (error.status === 500) return;
                // console.error(error);
            });
    }

}
